import {
  PartialProduktV11,
  StatePreV11,
  StateV11,
} from './11_fevorvertragsnummer_implementieren.interface';

export const fevorvertragsnummer = (previousState: StatePreV11, newVersion: number): StateV11 => {
  const migratedProdukte = previousState.produkte.map(produkt => {
    return {
      ...produkt,
      vorvertragsnummer: produkt.vorvertragsnummer
        ? [
            {
              spLaufnummer: null,
              vertragsnummer: produkt.vorvertragsnummer,
            },
          ]
        : produkt.vorvertragsnummer,
    } as PartialProduktV11;
  });
  return {
    ...previousState,
    version: newVersion,
    produkte: migratedProdukte,
  };
};
